import React from 'react'
import './style.css'

import stephenAvatarSrc from './stephen.svg'
import stipeAvatarSrc from './stipe.svg'
import tommyAvatarSrc from './tommy.svg'

const TestingLink = ({ to, label }) => (
  <a href={to}
    target="_blank"
    rel="noopener noreferrer"
    className="testing-tips-link">
    {label}
  </a>
)

const BestPracticesLink = () => (
  <TestingLink to="https://devdocs.drift.com" label="Best Practices" />
)

const FreeTestAccountLink = () => (
  <TestingLink to="https://app.drift.com/letsgo" label="free test account" />
)

const InstallWidgetLink = () => (
  <TestingLink to="https://app.drift.com/settings/widget" label="install the Drift Widget" />
)

const NgrokLink = () => (
  <TestingLink to="https://ngrok.com" label="ngrok" />
)

const TIPS = [
  {
    name: 'Stephen Webel',
    role: 'Drift Engineer',
    avatarSrc: stephenAvatarSrc,
    tip: (
      <span>
        Building against a <FreeTestAccountLink /> and not your actual account helps to create a safe environment for testing.
      </span>
    )
  },
  {
    name: 'Stipe Latkovic',
    role: 'Drift Tech Lead',
    avatarSrc: stipeAvatarSrc,
    tip: (
      <span>
        You can <InstallWidgetLink /> on a staging site to start playing around with your custom app in a safe environment.
      </span>
    )
  },
  {
    name: 'Tommy Hu',
    role: 'Drift Engineer',
    avatarSrc: tommyAvatarSrc,
    tip: (
      <span>
        While I was working on creating a sample bot I found that POSTing in testing requests to my bot was helpful. You can use <NgrokLink /> to forward events.
      </span>
    )
  }
]

const TestingTip = ({ name, role, avatarSrc, tip }) => (
  <div className="testing-tip-wrapper">
    <img
      className="testing-tip-avatar"
      src={avatarSrc}
      alt="avatar"
    />
    <div>
      <span className="testing-tip">
        “{tip}
      </span>
      <span className="testing-tip-name-role">
        {name}, {role}
      </span>
    </div>
  </div>
)

const TestingTips = () => (
  <div className="testing-tips">
    <span className="page-title">
      Tips for Testing
    </span>
    <p className="page-description">
      Ready to start testing your app? Our team outlined some helpful tips to keep in mind - check out our {<BestPracticesLink />} for the full round up!
    </p>
    <div>
      {TIPS.map((tip, index) =>
        <TestingTip key={index} {...tip} />
      )}
    </div>
  </div>
)

export default TestingTips
